import { useMemo } from "react";
import {
  useGetOrganizationsQuery,
  useGetSubscriptionsQuery,
  useGetPlansQuery,
  useGetBrokersQuery,
  useGetUsersQuery,
} from "../../../redux/api";
import { StatCard } from "../../../components/StatCard";
import {
  IconBuilding,
  IconCheck,
  IconClipboard,
  IconUsers,
  IconGroups,
} from "../../../components/icons";

// Home → Platform Owner. Platform-wide overview across every organization.
const PlatformOwnerHome = () => {
  const { data: organizations = [], isLoading: loadingOrgs } =
    useGetOrganizationsQuery();
  const { data: subscriptions = [] } = useGetSubscriptionsQuery();
  const { data: plans = [] } = useGetPlansQuery();
  const { data: brokers = [] } = useGetBrokersQuery();
  const { data: users = [] } = useGetUsersQuery();

  const activeSubscriptions = useMemo(
    () =>
      subscriptions.filter((s) => (s.status ?? "").toLowerCase() === "active")
        .length,
    [subscriptions],
  );

  const recentOrganizations = useMemo(
    () =>
      [...organizations]
        .sort((a, b) => (b.createdAt ?? "").localeCompare(a.createdAt ?? ""))
        .slice(0, 6),
    [organizations],
  );

  return (
    <div className="dashboard">
      <div className="dashboard-banner">
        <div>
          <h1>Platform Overview</h1>
          <p>Everything happening across every organization on the platform.</p>
        </div>
      </div>

      <div className="stat-grid">
        <StatCard
          label="Organizations"
          value={loadingOrgs ? "…" : organizations.length}
          tone="primary"
          icon={<IconBuilding />}
        />
        <StatCard
          label="Active subscriptions"
          value={activeSubscriptions}
          hint={`${subscriptions.length} total`}
          tone="success"
          icon={<IconCheck />}
        />
        <StatCard
          label="Plans"
          value={plans.length}
          tone="primary"
          icon={<IconClipboard />}
        />
        <StatCard
          label="Brokers"
          value={brokers.length}
          tone="primary"
          icon={<IconGroups />}
        />
        <StatCard
          label="Users"
          value={users.length}
          tone="primary"
          icon={<IconUsers />}
        />
      </div>

      <section className="panel">
        <div className="panel__head">
          <div>
            <h2>Recent organizations</h2>
            <p className="panel__sub">Latest {recentOrganizations.length}</p>
          </div>
        </div>
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody>
              {recentOrganizations.length === 0 ? (
                <tr>
                  <td className="data-table__empty" colSpan={3}>
                    No organizations yet.
                  </td>
                </tr>
              ) : (
                recentOrganizations.map((org) => (
                  <tr key={org.id}>
                    <td className="cell-title">{org.name}</td>
                    <td>
                      <span className="pill pill--neutral">{org.status}</span>
                    </td>
                    <td className="cell-date">
                      {org.createdAt
                        ? new Date(org.createdAt).toLocaleDateString()
                        : "—"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default PlatformOwnerHome;
